import React from "react";

import { ModalTypes } from "constants/navigation";

import { CreateIntegrationBusinessModal } from "./Modal";

export function Adapter(props) {
  const { hash } = props;
  const hashParams = hash[ModalTypes.CreateIntegrationBusiness] || null;

  const [integrationCredentialType, businessId, options] =
    JSON.parse(hashParams);
  const { returnTo } = hash;
  const decodedReturnTo = returnTo ? atob(returnTo) : "";

  return (
    <CreateIntegrationBusinessModal
      integrationCredentialType={integrationCredentialType}
      businessId={businessId}
      options={options}
      returnTo={decodedReturnTo}
    />
  );
}
